import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fbpvksp7qw: FaireBrandEntity = {
  token: "b_fbpvksp7qw",
  type: "brand",
  name: "Kōv Essentials (No duties or tariffs for CA+USA)",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5872864747d92c3643734d9bef98acc5df3f9d5203a16b6e46c60dab23f743b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a0d8dabfcf0132179ab5e1aa47893ecb22fa4e0ebc1046f9686610f18339b3d6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a5872864747d92c3643734d9bef98acc5df3f9d5203a16b6e46c60dab23f743b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a0d8dabfcf0132179ab5e1aa47893ecb22fa4e0ebc1046f9686610f18339b3d6.png",
  location: "Burlington, ON, CAN",
  minimumOrderDollars: 600,
  rating: 5,
  reviewCount: 3,
  isInsider: false,
  description:
    "Kōv Essentials was born out of an apparent need for hair essentials that are both stylish and functional; at Kōv Essentials, we understand that hair is not a one-size-fits-all category. No matter your hair texture, thickness, or length, we are proud to offer a product that is made for you.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.664Z",
    importedBy: "entity-db-cli",
  },
};
